import { render, staticRenderFns } from "./UtfPayloadView.vue?vue&type=template&id=f01591c6&scoped=true&"
import script from "./UtfPayloadView.vue?vue&type=script&lang=ts&"
export * from "./UtfPayloadView.vue?vue&type=script&lang=ts&"
import style0 from "./UtfPayloadView.vue?vue&type=style&index=0&id=f01591c6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f01591c6",
  null
  
)

export default component.exports